/**
 * Default branding images to use when no custom branding is provided
 */
export const brandingImages = {
  dashboardImage: '/orderly-dashboard.jpg',
  logoImage: '/orderly-logo-circle.png',
};
